export function Newsletter() {
  set(document.querySelectorAll('.js-news-letter'));

  function set(targets) {
    for (let i = 0; i < targets.length; i++) {
      NewsLetterInstance(targets[i]);
    }
  }

  function NewsLetterInstance(el) {
    const subscribeUrl = el.dataset.subscribeUrl;
    const unsubscribeUrl = el.dataset.unsubscribeUrl;

    let isUnsubscribe = false;
    let isSending = false;

    const input = el.querySelector('.js-news-letter-mail-address');
    const submit = el.querySelector('.js-news-letter-submit');

    if (!subscribeUrl || !input || !submit) return;

    input.addEventListener('input', () => {
      input.setCustomValidity('');
    });

    submit.addEventListener('click', (e) => {
      e.preventDefault();
      send();
    });

    input.addEventListener('keydown', (e) => {
      if (e.keyCode === 13) {
        e.preventDefault();
        send();
      }
    });

    function send() {
      if (isSending) return;

      const email = getValidEmail();
      if (!email) return;

      const formData = new FormData();
      formData.set('email', email);
      const url = isUnsubscribe ? unsubscribeUrl : subscribeUrl;

      fetch(url, {
        method: 'POST',
        body: formData,
      })
        .then((res) => res.text())
        .then((data) => {
          if (data) {
            success();
          } else {
            error();
          }
        })
        .catch(() => {
          error();
        });

      isSending = true;
      input.value = '送信中';
      sending();
    }

    function getValidEmail() {
      input.setCustomValidity('');
      const email = input.value.trim();

      if (!email) {
        input.setCustomValidity('メールアドレスを入力してください。');
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        input.setCustomValidity('メールアドレスの形式で入力してください。');
      }

      if (!input.checkValidity()) {
        if (typeof input.reportValidity === 'function') {
          input.reportValidity();
        }
        input.focus();
        return '';
      }

      input.value = email;
      return email;
    }

    function sending() {
      if (!isSending) return;
      input.value += ' .';
      setTimeout(() => {
        sending();
      }, 1000);
    }

    function success() {
      isSending = false;
      input.value = '';
      input.placeholder = `送信完了！${isUnsubscribe ? '解約' : '登録'}完了メールをお送りしました。`;
    }

    function error() {
      isSending = false;
      input.value = '';
      input.placeholder = '送信失敗 再度お試しください。';
    }
  }
}
